export default __webpack_public_path__ + "static/media/bigImage.6eebfdbd.jpg";